import {
  fixedPageDataFetcher,
  FixedPageTemplate,
} from "components/templates/FixedPage";

export default FixedPageTemplate;

export async function getServerSideProps(context) {
  return await fixedPageDataFetcher(context, {
    path: "/events",
  });
}
